import { useState, useEffect } from 'react';
import { ethers } from 'ethers';

// Укажите URL вашего узла Scroll
const providerUrl = 'https://rpc.scroll.io'; // Замените на URL вашего узла Scroll

// Создайте провайдера
const provider = new ethers.JsonRpcProvider(providerUrl);

const useLatestBlock = () => {
	const [blockNumberLastest, setBlockNumber] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchLatestBlock = async () => {
			try {
				setLoading(true);
				const latestBlockNumber = await provider.getBlockNumber();
				setBlockNumber(latestBlockNumber);
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};

		fetchLatestBlock();
	}, []); // Пустой массив зависимостей означает, что эффект сработает только при первом монтировании

	return { blockNumberLastest, loading, error };
};

export default useLatestBlock;
